<!--
 * @Description: 特材加工结算审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-21 16:54:22
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ contract.id }}</span>
                <span class="text">制单日期：{{ statements.createTime }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div class="bill_top">
              <!-- <span><span class="text">客户名称：</span>{{billDetails1.unitName}}</span> -->
              <span><span class="text">甲方单位：</span>{{ statements.firstParty }}</span>
              <span><span class="text">乙方单位：</span>{{ statements.secondParty }}</span>
              <!-- <span><span class="text">站点名称：</span>{{billDetails1.stationName}}</span> -->
              <span><span class="text">结算时间：</span>{{ statements.settleStartTime }}至{{ statements.settleEndTime }}</span>
              <span><span class="text">结算单编号：</span>{{ statements.balanceNo }}</span>
            </div>
            <div class="bill_title1">结算信息</div>
            <template v-for="(item, index) in billDetails">
              <div v-if='createtype == 1' :key="index">
                <div class="bill_subtitle">
                  <span><span class="text">{{ item.contractName }}</span></span>
                </div>
                <el-table :key="index" :header-cell-style="{ background: '#f3f6f9' }"
                  :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="item.data"
                  tooltip-effect="dark">
                  <el-table-column label="时间段" align="center" width="175">
                    <template slot-scope="scope"> {{ scope.row.settleStartTime ? scope.row.settleStartTime.split(' ')[0] :
                      '-'
                    }} - {{ scope.row.settleEndTime ? scope.row.settleEndTime.split(' ')[0] : '-' }} </template>
                  </el-table-column>
                  <el-table-column label="产品名称" align="center" prop="productName" width="auto"></el-table-column>
                  <el-table-column label="签收数量（方）" align="center" width="auto">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.quantity" onchange="if(!value)value=0" placeholder="请输入"
                        style="width: 100%" disabled
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="产品单价（元/m³）" align="center" width="auto">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.productPrice" onchange="if(!value)value=0" placeholder="请输入"
                        style="width: 100%" disabled
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="增加金额（元）" align="center" width="auto">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.addPrice" disabled onchange="if(!value)value=0" placeholder="请输入"
                        style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                        @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                        @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="结算金额（元）" align="center" width="auto" disabled>
                    <template slot-scope="scope">
                      {{ Math.round(((Number(scope.row.productPrice || 0) + Number(scope.row.addPrice || 0)) *
                        Number(scope.row.quantity)) * 100) / 100 }}
                    </template>
                  </el-table-column>
                </el-table>
                <div style="border-top: 0px" class="combined">小计：签收数量【{{ combined(item.data) }}】方，结算金额【{{
                  combined2(item.data)
                }}】元</div>
              </div>
            </template>
            <template v-for="(item, index) in billDetails">
              <div v-if='createtype == 2' :key="index">
                <div class="bill_subtitle">
                  <span><span class="text">{{ item.contractName }}</span></span>
                </div>
                <el-table :key="index" :header-cell-style="{ background: '#f3f6f9' }"
                  :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="item.data"
                  tooltip-effect="dark">
                  <el-table-column label="生产站点" align="center" width="auto">
                    <template slot-scope="scope">
                      <span>{{ scope.row.contractName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="签收数量（方）" align="center" width="auto">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.quantity" onchange="if(!value)value=0" placeholder="0"
                        style="width: 100%" disabled
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="加工费（元/m³）" align="center" width="auto">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.processPrice" onchange="if(!value)value=0" placeholder="0"
                        style="width: 100%" disabled
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="结算金额（元）" align="center" width="auto">
                    <template slot-scope="scope">
                      {{ Math.round((Number(scope.row.quantity || 0) * Number(scope.row.processPrice || 0)) * 100) / 100
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
            <!-- 特殊条款 -->
            <div class="bill_title1">特殊条款描述</div>
            <div>{{ contract.contractClause }}</div>
            <div class="bill_title1">调整金额</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="deductionList" tooltip-effect="dark">
              <el-table-column label="站点" align="center">
                <template slot-scope="scope">
                  <el-select ref="stationName" v-model="scope.row.stationId" style="width: 100%" placeholder="请选择站点"
                    @change="
                      $nextTick(() => {
                        scope.row.station = $refs.stationName.selectedLabel;
                      })
                      ">
                    <el-option v-for="item in stationList" :key="item.stationId" :label="item.station"
                      :value="item.stationId"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="调整类型" align="center">
                <template slot-scope="scope">
                  <el-select ref="deductionType1" v-model="scope.row.adjustModule" :disabled="!cansave"
                    style="width: 100%" placeholder="请选择调整类型" @change="
                      $nextTick(() => {
                        scope.row.deductionType = $refs.deductionType1.selectedLabel;
                      })
                      ">
                    <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="调增/调减" align="center" prop="type">
                <template slot-scope="scope">
                  <el-select ref="type" v-model="scope.row.type" style="width: 100%" placeholder="请选择" disabled>
                    <el-option :key="1" label="调增" :value="0"></el-option>
                    <el-option :key="2" label="调减" :value="1"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="调整金额" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.adjustMoney" placeholder="请输入" style="width: 100%"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" disabled
                    @input="scope.row.adjustMoney = $regExp.checkNum(scope.row.adjustMoney)"
                    @blur="scope.row.adjustMoney = $regExp.blurCheckNum(scope.row.adjustMoney)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="是否影响开票" align="center">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isInvoice" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" placeholder="请输入" disabled style="width: 100%"
                    clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="cansave" label="操作" align="left" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="bill_title">结算合计</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="totalList" tooltip-effect="dark">
              <el-table-column label="甲方单位" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.firstParty }}</div>
                </template>
              </el-table-column>
              <el-table-column label="乙方单位" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.secondParty }}</div>
                </template>
              </el-table-column>
              <el-table-column label="产品费用（元）" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.money ? scope.row.money : "---" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="调整金额（元，不影响开票）" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.noAdjustCost ? scope.row.noAdjustCost : "---" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="调整金额（元，影响开票）" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.isAdjustCost ? scope.row.isAdjustCost : "---" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.totalCost ? scope.row.totalCost : "---" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="开票金额（元）" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.ticketCost ? scope.row.ticketCost : "---" }}</div>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="combined">小计：收货量【{{combined(totalList1,'statementNum')}}】，结算金额【{{combined(totalList1,'statementMoney')}}】</div> -->
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title="title" :showSendVisible="showSendVisible"
                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                @handleBusiness="handleBusiness" @resetFlowState="resetFlowState" @changeAudio="changeAudio" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import FlowContent from "@/components/WorkFlow/flowContent";
import FlowHeader from "@/components/WorkFlow/flowHeader";
import { getDicType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
import { _debounce } from "@/utils/utils.js";
import { update_status } from "@/api/wise/Wise_rentunit/Wise_rentunit5.js";
import { look_unitinternal, save_unitinternal } from "@/api/wise/internalunit.js";
export default {
  mixins: [mixin],
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: "内部单位结算审批",
      billCode: "",
      billDate: "",
      applyPerson: "",
      taskTypeText: ["发起", "已保存", "审批中", "已完成", "撤销", "不通过"],
      taskStatus: 0,
      readOnly: false,
      showSendVisible: false,
      billDetails1: {
        list: [],
      },
      totalList1: [],
      deductionTypes: [],
      statements: {},
      billDetails: [],
      contract: {},
      adjustList: [],
      createtype: 1,
      totalList: [
        {
          firstParty: "",
          secondParty: '',
          money: 0,
          noAdjustCost: 0,
          isAdjustCost: 0,
          totalCost: 0,
          ticketCost: 0,
        },
      ],
      deductionList: [],
      cansave: false,
      stationList: [],
    };
  },
  watch: {
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        deductionList: this.deductionList,
        billDetails: this.billDetails
      };
    },
  },
  methods: {
    changeAudio(e) { //操作成功后修改审核状态]
      console.log('------------------changeAudio')
      const { query } = this.$route;
      console.log('query', query)
      let id;
      id = JSON.parse(query.dataContent).id
      let data = {
        innerStatements: {
          id: id,
          auditStatus: e,
        }
      }
      console.log(data)
      save_unitinternal(data).then(res => {
        console.log(res)
      })
    },
    //不同意回调
    resetFlowState() {
      this.handleBusiness();
    },
    /**结算合计*/
    settotalList: _debounce(function () {
      this.totalList[0].firstParty = this.contract.firstParty;
      this.totalList[0].secondParty = this.contract.secondParty;
      this.totalList[0].money = this.productallcost();
      this.totalList[0].isAdjustCost = this.combined3(2);
      this.totalList[0].noAdjustCost = this.combined3(3);
      this.totalList[0].totalCost = this.combinedall(1);
      this.totalList[0].ticketCost = this.combinedall(2);
    }),
    /*结算金额合计type:1结算金额2开票金额 */
    combinedall(type) {
      let num = 0;
      let row = this.totalList[0];
      let totalCost = 0;
      if (type == 1) {
        num = totalCost + Number(row.money) + Number(row.isAdjustCost) + Number(row.noAdjustCost)
      } else if (type == 2) {
        num = totalCost + Number(row.money) + Number(row.isAdjustCost) + Number(row.noAdjustCost) - Number(row.noAdjustCost)
      }
      return num.toFixed(2);
    },
    /**签收数量计算合计*/
    combined(arr) {
      let num = 0;
      console.log(arr)
      arr.forEach(res => {
        num = Number(res.quantity) + num;
      });
      return num.toFixed(2);
    },
    /* 产品费用总额计算 */
    productallcost() {
      let num = 0  //此处判断代加工和购销 进行产品费用合计计算
      if (this.createtype == 1) {
        this.billDetails.map(item => {
          item.data.forEach(i => {
            num = Math.round(((Number(i.productPrice || 0) + Number(i.addPrice || 0)) * Number(i.quantity)) * 100) / 100 + num;
          });
        })
      } else if (this.createtype == 2) {
        this.billDetails.map(item => {
          item.data.forEach(i => {
            num = Math.round((Number(i.processPrice) * Number(i.quantity)) * 100) / 100 + num;
          });
        })
      }
      return num.toFixed(2);
    },
    /**产品费用合计*/
    combined2(arr) {
      let num = 0;
      console.log(arr)
      arr.forEach(res => {
        num = Math.round(((Number(res.productPrice || 0) + Number(res.addPrice || 0)) * Number(res.quantity)) * 100) / 100 + num;
      });
      return num.toFixed(2);
    },
    /*调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined3(type) {
      let num = 0;
      this.deductionList.forEach(res => {
        if (type == 1) {
          num = res.type ?  num - Number(res.adjustMoney) : num + Number(res.adjustMoney);
        } else if (type == 2) {
          if (res.isInvoice == 1) {
            num = res.type ?  num - Number(res.adjustMoney) : num + Number(res.adjustMoney) ;
          }
        } else if (type == 3) {
          if (res.isInvoice == 0) {
            num = res.type ?  num - Number(res.adjustMoney) : num + Number(res.adjustMoney) ;
          }
        }
      });
      return num.toFixed(2);
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: "/icps/system/sign/settlement/processingFee/updateAuditStatus",
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 3,
            statusType: 1,
          },
          httpMethod: "post",
        },
        process_failure: {
          url: "/icps/system/sign/settlement/processingFee/updateAuditStatus",
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 4,
            statusType: 1,
          },
          httpMethod: "post",
        },
      };
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description:
     * @Param: 1为保存，2为最后提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      const { query } = this.$route;
      if (type == 1) {
        update_status({
          statementNo: query.id,
          auditStatus: 2,
          statusType: 1,
        }).then(() => { });
        return;
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
        // 发起流程
        this.showSendVisible = true;
        return;
      }
      const data = {
        dataSource: "sign_internalunit",
        dataContent: JSON.stringify({ id: JSON.parse(query.dataContent).id }), // 业务数据
      };
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param:
     * @Author: wangwangwang
     */
    initFlowsData(id) {
      var _this = this
      const { query } = this.$route;
      // _this.createtype = query.contractType
      look_unitinternal({ id: id }).then(res => {

        _this.contract = res.data.contract
        _this.createtype = _this.contract.contractTypeId
        _this.statements = res.data.statements
        var billDetails = _this.copy(res.data.detailMap)
        for (let key in billDetails) {
          billDetails[key].forEach(r => {
            r.settleStartTime = _this.statements.settleStartTime
            r.settleEndTime = _this.statements.settleEndTime
            r.contractName = key
          })
          let item = { contractName: key, data: billDetails[key] }
          _this.billDetails.push(item)
        }
        _this.deductionList = res.data.adjustList
        _this.stationList = res.data.stationList


        // this.billDetails1 = res.data.data
        // let statementNumTotal = res.data.detalList.reduce((pre, cur) => {
        //   pre = pre * 1 + cur.statementNum * 1;
        //   return pre;
        // }, 0);
        // this.billDetails1.detalList.forEach(ress => {
        //   //结算量
        //   if ((ress.statementNum / statementNumTotal) * 1 < ress.scale) {
        //     ress.charge = "否";
        //   } else {
        //     ress.charge = "是";
        //   }
        // });
        // let deduction = res.data.deductionList.reduce((pre, cur) => {
        //   pre = pre + cur.deduction;
        //   return pre;
        // }, 0);
        // res.data.total.deduction = deduction;
        // this.totalList1 = [];
        // this.totalList1.push(res.data.total);
      });
      if (query.type * 1 !== 1) {
        this.title = query.taskName;
      }

      this.billDate = query.createTime;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  async created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type);
    const { data } = await getDicType({ code: "deductionType" });
    this.deductionTypes = data.items;
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) {
      // 发起流程
      this.initFlowsData(JSON.parse(query.dataContent).id);
      this.$refs.flowcontent.initBaseData("sign_internalunit");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      this.applyPerson = getUserInfo().userRealName;
      return;
    }
    this.initFlowsData(JSON.parse(query.dataContent).id);
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.bill_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 40px;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}

.bill_subtitle {
  padding: 20px 0;

  >span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}

.flows-details {
  margin-top: 20px;
}

.info {
  padding: 0 20px;
  background: #fff;

  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;

    .left {
      @include discen_al;
    }

    .text {
      margin-left: 60px;
    }
  }
}

.nav_title {
  @include discen_al;
  align-items: flex-end;

  >div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }

  i {
    margin-left: 5px;
  }

  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}

.dialoginfo {
  padding: 0;
}

.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}

.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}

/*弹窗*/
.dialoginfo-title {
  >div {
    cursor: pointer;
  }

  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);

  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;

    >div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }

  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }

  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);

    >div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}

.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);

  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>